var $ = jQuery;

// header nav padding
function headerPad() {
	// Header pad
	var height = $('#header .sticky').outerHeight();
	console.log("Nav height: ", height);
	$('#header').attr('style', 'height: ' + height + 'px !important');
}


// Scroll Direction
function scrollDirection() {
	var position = $('html').scrollTop();
  var header = $('#header');
	$( window ).scroll(function() {
		var scroll = $('html').scrollTop();
    if (scroll > position) {
			// scrolling downwards
			header.addClass('down');
			header.removeClass('up');
		} else {
			// scrolling upwards
			header.addClass('up');
			header.removeClass('down');
		}
    if (scroll >= 100) {
			header.addClass('moving');
		} else {
			header.removeClass('moving');
      header.removeClass('up');
      header.removeClass('down');
		}
		position = scroll;
		window.scrollpos = position;
		//console.log("scroll pos: ", window.scrollpos)

	});
}

//mean menu
function meanmenuinit() {
  $('#site-navigation > div').meanmenu({ 
    meanScreenWidth: "1110",
    meanMenuContainer: '.mobile-menu'
 });

 $('.mobile-menu-button button').click(function(){
    $(this).toggleClass('mobile-menu-open');
    $(".mean-nav ul:first").slideToggle();
  });
}

//popups
  function initPopups() {
    //find toggles
    $( ".js-video-play" ).each(function( index ) {
      $(this).click(function(){
        togglePopup($( this ).data( "video-id" ));
      });
    });

    //init popups
    $( ".popup" ).each(function( index ) {
      var id = $(this).attr('id');
      $(this).find('.exit').click(function(){
        togglePopup(id)
      });
    });

}

//open or close popup
function togglePopup(id) {  
    var popup = $('#' + id);
    var iframe = popup.find('iframe');
    var src = iframe.data("src");
    var doc = $('body');

    if (popup.hasClass('active')) {
        popup.removeClass('active');
        doc.css('overflow', '');
        iframe.attr('src', '');
    } else {
        popup.addClass('active');
        doc.css('overflow', 'hidden');
        iframe.attr('src', src);
    }

}

//Analytics events

//resource ctas
$('.resource-cta .btn').click(function(){
  var gated = $(this).hasClass('gated');
  var uri = new URL($(this).attr("href"));
  var resource = uri.pathname.split(/[\\\/]/).pop();
  if(!resource) {
    var resource = uri;
  }
  var category = "resource_ungated";
  if(gated){
    category = "resource_gated";
  }
  //send analytics event
  if (gtag) {
    console.log("Analytics | Resource CTA Clicked: ", category, resource);
    gtag('event', 'clicked', {
        'event_category': `${category}`,
        'event_label': `${resource}`,
        'value': 1,
    });
  }
});

//vimeo video events
if($('.vimeo-embed').length){
  var iframe = $('.vimeo-embed iframe');
  var player = new Vimeo.Player(iframe);
  var video = iframe.attr("src");

  player.on('play', function() {
      console.log('played the video!');
      //send analytics event
      if (gtag) {
          console.log("Analytics | Video Played: ", video);
          gtag('event', 'played', {
              'event_category': "video",
              'event_label': `${video}`,
              'value': 1,
          });
      }
  });
  player.on('pause', function (data) {
      console.log("pause: ", data);
      //send analytics event
      if (gtag) {
        console.log("Analytics | Video Paused: ", video);
        gtag('event', 'pause', {
            'event_category': "video",
            'event_label': `${video}`,
            'value': 1,
        });
    }
  });
  player.on('ended', function (data) {
      console.log("Video Ended: ", data);
      //send analytics event
      if (gtag) {
        console.log("Analytics | Video Ended: ", video);
        gtag('event', 'ended', {
            'event_category': "video",
            'event_label': `${video}`,
            'value': 1,
        });
    }
  });
  player.on('timeupdate', function (data) {
      var duration = data.seconds;
      console.log("Video watched: ", duration);
  });
}

//vimeo video events
if($('.youtube-embed').length){
  //add youtube api
  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  //get video id
  var videoid = $('#youtube-iframe').attr("data-video-id")
  //setup player
  var player;
  function onYouTubeIframeAPIReady() {
    player = new YT.Player('youtube-iframe', {
      height: '390',
      width: '640',
      videoId: videoid,
      playerVars: {
        'playsinline': 1
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
  }
  //player events
  function onPlayerReady(event) {
    //event.target.playVideo();
  }

  var done = false;
  function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING) {
      console.log('played the video!');
      //send analytics event
      if (gtag) {
        console.log("Analytics | Video Played: ", videoid);
        gtag('event', 'played', {
            'event_category': "video",
            'event_label': `${videoid}`,
            'value': 1,
        });
      } 
    }
    if (event.data == YT.PlayerState.PAUSED) {
      console.log("pause: ");
      //send analytics event
      if (gtag) {
        console.log("Analytics | Video Paused: ", videoid);
        gtag('event', 'pause', {
            'event_category': "video",
            'event_label': `${videoid}`,
            'value': 1,
        });
      }
    }
    if (event.data == YT.PlayerState.ENDED) {
      console.log("Video Ended: ");
      //send analytics event
      if (gtag) {
        console.log("Analytics | Video Ended: ", videoid);
        gtag('event', 'ended', {
            'event_category': "video",
            'event_label': `${videoid}`,
            'value': 1,
        });
      }
    }
  }
  function stopVideo() {
    player.stopVideo();
  }  
}



/**
 * ----------------------------------------------------------------------------------------
 * MAKE IT SO
 * ----------------------------------------------------------------------------------------
 */
 //jQuery = $; // make jquery available to blocks

 $(window).on('load', function() {
   // console.log("footer.js | load");
   headerPad();
 });
 $(window).on('resize', function() {
   // console.log("footer.js | resize");
   headerPad();
 });
 
 $(window).on("orientationchange", function(event) {
   // console.log("footer.js | orientationchange");
   headerPad();
 });
 
 
 $(document).ready(function() {
  headerPad();
   scrollDirection();
   meanmenuinit();
   initPopups();
 });
 
 // back button event
 (function() {
   if (window.history && window.history.pushState) {
     /* $(window).on('popstate', function() {
       //console.log("footer.js | back button event");
 
     }); */
   }
 })();